module.exports = __webpack_public_path__ + "img/2.3864f1e3.jpg";